import { render, staticRenderFns } from "./Servizio.vue?vue&type=template&id=43526888&"
import script from "./Servizio.vue?vue&type=script&lang=js&"
export * from "./Servizio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports